<template>
  <div id="clubAfterBefore">
    <div class="pr-2 py-1 club-title">
      <h3 class="d-inline-block text-color-grey fontsize-medium m-0">
        تصویر قبل / بعد باشگاه
      </h3>
    </div>
    <div class="d-flex flex-column align-items-start gap-10 mt-4">
      <div class="col-12 col-md-6">
        <p class="m-0 w-s-nowrap col-5">انتخاب محصول:</p>
        <multiselect
          v-model="selectedProduct"
          placeholder="محصول"
          open-direction="bottom"
          label="title"
          track-by="id"
          :options="products"
          :allow-empty="false"
          :searchable="true"
          :multiple="false"
          :close-on-select="true"
          :show-labels="false"
          :disabled="disabled"
        >
          <template slot="noOptions"> موردی یافت نشد </template>
          <template slot="noResult"> موردی یافت نشد </template>
        </multiselect>
      </div>
      <b-form-group
        label="تصویر قبل از استفاده از محصول"
        class="col-12 col-md-6"
      >
        <b-form-file v-model="beforeImage"></b-form-file>
      </b-form-group>
      <b-form-group
        label="تصویر بعد از استفاده از محصول"
        class="col-12 col-md-6"
      >
        <b-form-file v-model="afterImage"></b-form-file>
      </b-form-group>
      <b-form-group label="توضیحات *" class="col-12 col-md-6">
        <b-form-textarea v-model="description"></b-form-textarea>
      </b-form-group>
      <div class="col-12 col-md-6">
        <button class="btn btn-after-before-color" type="button" @click="send">
          ثبت تصاویر
        </button>
      </div>
    </div>
    <div class="pr-2 py-1 mt-5 mb-2 club-title" v-if="oldRequest.length">
      <h3 class="d-inline-block text-color-grey fontsize-medium m-0">
        تصاویر ارسال شده
      </h3>
    </div>
    <b-table
      responsive
      hover
      bordered
      :items="oldRequest"
      :fields="oldRequestFields"
    >
      <template #cell(index)="row">
        {{ row.index + 1 }}
      </template>
      <template #cell(after_image)="row">
        <a target="_blank" :href="BaseURL + row.item.after_image[0]">
          <img
            :src="BaseURL + row.item.after_image[0]"
            class="imageInTable"
            alt=""
          />
        </a>
      </template>
      <template #cell(before_image)="row">
        <a target="_blank" :href="BaseURL + row.item.before_image[0]">
          <img
            :src="BaseURL + row.item.before_image[0]"
            class="imageInTable"
            alt=""
          />
        </a>
      </template>
      <template #cell(product)="row">
        {{ row.item.product.title }}
      </template>
      <template #cell(approved)="row">
        <span v-if="row.item.approved == 1" class="badge badge-success">
          تایید شده
        </span>
        <span v-else class="badge badge-info"> تایید نشده </span>
      </template>
    </b-table>
  </div>
</template>
<script>
import ChevronLeft from "@/parts/Front/components/Icon/ChevronLeft.vue";
import { BFormGroup, BFormFile, BFormTextarea, BTable } from "bootstrap-vue";
export default {
  name: "ClubAfterBefore",
  props: ["clubData", "clubColor"],
  components: {
    ChevronLeft,
    BFormGroup,
    BFormFile,
    BFormTextarea,
    BTable,
  },
  data() {
    return {
      url: "customer/customers_club/get_bought_products",
      BaseURL: "https://api.benedito.ir/storage/",
      products: [],
      selectedProduct: "",
      disabled: false,
      afterImage: "",
      beforeImage: "",
      description: "",
      oldRequest: [],
      oldRequestFields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "after_image",
          label: "عکس قبل",
        },
        {
          key: "before_image",
          label: "عکس بعد",
        },
        {
          key: "product",
          label: "محصول",
        },
        {
          key: "approved",
          label: "وضعیت",
        },
      ],
    };
  },
  mounted() {
    this.getBoughtProducts();
    this.getOldRequest();
  },
  methods: {
    getOldRequest() {
      this.$axios
        .post("customer/customers_club/get_before_after_images")
        .then((res) => {
          this.oldRequest = res.data.data;
        });
    },
    async getBoughtProducts() {
      await this.$axios
        .post(this.url)
        .then((res) => {
          this.products = res.data.data.products;
        })
        .catch((e) => {
          this.$root.notify(e);
        });
    },
    send() {
      this.disabled = true;
      let formData = new FormData();
      formData.append(
        "product_id",
        this.selectedProduct ? this.selectedProduct.id : ""
      );
      formData.append("after_image", this.afterImage);
      formData.append("before_image", this.beforeImage);
      formData.append("description", this.description);
      this.$axios
        .post("customer/customers_club/set_before_after_images", formData)
        .then((res) => {
          this.$root.notify(res, "success");
          this.selectedProduct = "";
          this.beforeImage = "";
          this.afterImage = "";
          this.description = "";
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
</script>
<style scoped>
.club-title {
  border-right-width: 3px;
  border-right-style: solid;
  border-right-color: v-bind(clubColor);
}
#clubAfterBefore .inner-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
}
#clubAfterBefore .inner-container label {
  background: v-bind(clubColor);
  color: #ffffff;
}
#clubAfterBefore .btn-after-before-color {
  background: v-bind(clubColor);
}
</style>
<style>
img.imageInTable {
  width: 50px;
}
</style>
